import isDarkOrHighContrastTheme from '%evp_theme/brandbook/appearance/isDarkOrHighContrastTheme';
import isHighContrastTheme from '%evp_theme/brandbook/appearance/isHighContrastTheme';
import { drawStrongInsetRing } from './strongStroke';

export default function createFilledButtonHover(theme, fill, ink) {
    if (!isHighContrastTheme(theme)) {
        return {
            backgroundColor: fill.dark,
        };
    }

    return {
        backgroundColor: theme.palette.background.paper,
        color: fill.main,
        boxShadow: drawStrongInsetRing(theme, fill.main),
        '@media (hover: none)': {
            backgroundColor: fill.main,
            color: ink,
            boxShadow: 'none',
        },
    };
}

export function createFilledOverlayButton(theme, fill) {
    const ink = isDarkOrHighContrastTheme(theme) ? fill.contrastText : theme.palette.grey.A100;

    return {
        backgroundColor: fill.main,
        color: ink,
        '&:hover': createFilledButtonHover(theme, fill, ink),
    };
}
